import React, { PureComponent, Component } from "react";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";
import { KeyboardArrowDown, KeyboardArrowUp, MoreVert } from "@material-ui/icons";
import { shouldUpdate, MergeStyles } from "../../utils/index";
import ShellPortal from "../ShellPortal/ShellPortal";
import autoBind from "../../libs/react-autobind/index";
/**
 * Use:
 * 
 			<Tooltip>
					...  //on hover these elems..
					<TooltipContent>
							...	 //..show these elems
					</TooltipContent>
				</Tooltip>

 */
@CSSModules(styles, { allowMultiple: true })
class TooltipImpl extends PureComponent {
	static defaultProps = {
		zIndex: 5,
		delay: 200, //ms popup delay or undefined for no delay

		rootClass: ""
	};
	static propTypes = {
		zIndex: PropTypes.number,
		classes: PropTypes.object //style overrides
	};

	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {
			open: false,
			pos: null
		};
		this.popup = React.createRef();
	}

	hover(e) {
		if (!this.state.open) {
			const pos = { x: e.clientX + 10, y: e.clientY + 10 };
			if (this.timeout) {
				clearTimeout(this.timeout);
				this.timeout = null;
			}
			this.timeout = setTimeout(() => {
				this.setState({ open: true, pos });
			}, this.props.delay);
		} else {
			// this.ignoreNextClose = true;
		}
	}

	//called when mouse leaves element
	leave(e) {
		setTimeout(() => {
			//if we left children hover elements but moved into the tooltip itself, dont hide the tooltip
			if (!this.ignoreNextClose) {
				if (this.timeout) {
					clearTimeout(this.timeout);
					this.timeout = null;
				}
				this.setState({ open: false });
			}
			this.ignoreNextClose = false;
		});
	}

	//called when mouse leaves tooltip element
	leaveTooltip(e) {
		setTimeout(() => {
			//if there isnt a pending show element, means we moved mouse outside tooltip and not onto the children hover element(s)
			if (!isNaN(this.timeout)) {
				this.setState({ open: false });
			}
			this.ignoreNextClose = false;
		});
	}

	render() {
		let style = {};
		if (this.popup.current && this.state.pos) {
			const xLimit = this.state.pos.x + this.popup.current.clientWidth + 10;
			const yLimit = this.state.pos.y + this.popup.current.clientHeight + 10;
			style.top =
				yLimit > window.innerHeight ? this.state.pos.y - (yLimit - window.innerHeight) : this.state.pos.y;
			style.left =
				xLimit > window.innerWidth ? this.state.pos.x - (xLimit - window.innerWidth) : this.state.pos.x;
		}

		const children = React.Children.toArray(this.props.children);
		const tooltipContent = children.find(x => x.type === TooltipContent);

		const kids = children.filter(x => x.type !== TooltipContent).map(x => {
			const existingHover = x.props.onMouseOver;
			const existingLeave = x.props.onMouseLeave;
			const clone = React.cloneElement(x, {
				onMouseOver: e => {
					this.hover(e);
					existingHover && existingHover(e);
				},
				onMouseLeave: e => {
					this.leave(e);
					existingLeave && existingLeave(e);
				},
				className: (x.props.className || "") + " _hasTooltip"
			});
			return clone;
		});

		return (
			<React.Fragment>
				{kids}
				<ShellPortal>
					{tooltipContent && (
						<div
							styleName={`_root ${this.props.rootClass}`}
							open={this.state.open}
							style={{ zIndex: this.props.zIndex ? this.props.zIndex + 1 : undefined, ...style }}
							ref={this.popup}
							onMouseOver={this.hover}
							onMouseLeave={this.leaveTooltip}
						>
							<div className={this.props.className} styleName="base">
								{tooltipContent}
							</div>
						</div>
					)}
				</ShellPortal>
			</React.Fragment>
		);
	}
}

/**
 * Use:
 * 
 			<Tooltip>
					...  //on hover these elems..
					<TooltipContent>
							...	 //..show these elems
					</TooltipContent>
				</Tooltip>

 */
const Tooltip  = MergeStyles(TooltipImpl, styles);
export default Tooltip;

export class TooltipContent extends PureComponent {
	render() {
		return this.props.children;
	}
}



// WEBPACK FOOTER //
// ./src/components/Tooltip/tooltip.js